module.exports = __webpack_public_path__ + "img/children-boy.7f6149bf.png";